import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';
import LatestNews from "./LatestNews";
import Video from "./Video";

import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';
// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://spst.in/myapp/api/uploads";

function Home() {

	const [uploads, setUploads] = useState([]);
	const [editId, setEditId] = useState(null);
	const [editName, setEditName] = useState('');

	useEffect(() => {
		fetchUploads();
	}, []);

	const fetchUploads = async () => {
		const res = await axios.get(`${API_BASE}/get.php`);
		setUploads(res.data);
	};

	const handleDelete = async (id) => {
		if (!window.confirm("Delete this record?")) return;
		await axios.post(`${API_BASE}/delete.php`, { id });
		fetchUploads();
	};

	const startEdit = (item) => {
		setEditId(item.id);
		setEditName(item.name);
	};

	const saveEdit = async () => {
		await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
		setEditId(null);
		fetchUploads();
	};

	const { t } = useTranslation();

	return (
		<div>

			<Slider />
			<Video />

			

			<div class="container-" style={{ marginTop: '60px',marginBottom:'50',display:'flex',alignItems:'center',justifyContent:'center',marginLeft:'auto !important',marginRight:'auto !important',width:'100%' }}>
				<div className="row">
					<div className="col-12 col-md-7" style={{backgroundImage:'url(./images/bg-1.png)',backgroundSize:'cover'}}>
						<p className="about" >
						{t("hp-1")}
						</p>
					</div>
					<div className="col-12 col-md-5" >
					<div style={{ display: 'flex', height:'', alignItems: 'center', justifyContent: 'center',backgroundSize:'cover',backgroundPosition:'center'}}>
						<img src="./images/maruthi.png" alt="maruthi" style={{width:'70%'}} />

					</div>
						{/* <img src="./images/home.jpeg" alt="Maruthi Temple" style={{ width: '100%', border: '1px inset silver' }} /> */}
					</div>

				</div>
			</div>

</div>

	);
}

export default Home;